<template>
  <div class="columns login-block">
    <div class="column is-2" />
    <div class="column is-8">
      <h2 class="subtitle is-2 has-text-centered">
        Register an Account
      </h2>
      <div class="box mb-30">
        <div class="columns">
          <div class="column is-6">
            <img
              src="https://rest.ahlpoker.com/image/get/161"
              style="width:160px;height:auto"
            >
          </div>
          <div class="is-clearfix column is-6">
            <router-link to="/">
              <button
                class="delete is-pulled-right mb-2"
                style="vertical-align: top"
                aria-label="close"
                @click="toggleSignup()"
              />
            </router-link>
          </div>
        </div>
        <form>
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label">Your username will be the email you provide below</label>
              </div>
              <div class="field">
                <label class="label">Password*</label>
                <p class="control">
                  <input
                    v-model="input.password"
                    class="input"
                    :class="{'is-danger': validationErrors.password}"
                    type="password"
                    placeholder="******"
                  >
                </p>
                <p
                  v-if="validationErrors.password"
                  class="help is-danger"
                >
                  This field is invalid
                </p>
              </div>
              <div class="field">
                <label class="label">Confirm Password*</label>
                <p class="control">
                  <input
                    v-model="input.confirm"
                    class="input"
                    type="password"
                    :class="{'is-danger': validationErrors.passwordConfirmation}"
                    placeholder="******"
                  >
                </p>
                <p
                  v-if="validationErrors.passwordConfirmation"
                  class="help is-danger"
                >
                  This field is invalid
                </p>
              </div>
              <hr>
              <div class="field">
                <label class="label">Full Name*</label>
                <div class="field is-horizontal">
                  <div class="field-body">
                    <div class="field">
                      <p class="control">
                        <input
                          v-model="input.first"
                          class="input"
                          :class="{'is-danger': validationErrors.firstName}"
                          type="text"
                          placeholder="John"
                        >
                      </p>
                      <p
                        v-if="validationErrors.firstName"
                        class="help is-danger"
                      >
                        This field is invalid
                      </p>
                    </div>
                    <div class="field middle">
                      <p class="control">
                        <input
                          v-model="input.middle"
                          class="input"
                          :class="{'is-danger': validationErrors.middleName}"
                          type="text"
                          placeholder="J"
                        >
                      </p>
                      <p
                        v-if="validationErrors.middleName"
                        class="help is-danger"
                      >
                        This field is invalid
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <p class="control">
                  <input
                    v-model="input.last"
                    class="input"
                    :class="{'is-danger': validationErrors.lastName}"
                    type="text"
                    placeholder="Smith"
                  >
                </p>
                <p
                  v-if="validationErrors.lastName"
                  class="help is-danger"
                >
                  This field is invalid
                </p>
              </div>
              <div class="field">
                <label class="label">Date of Birth*</label>
                <p class="control">
                  <input
                    v-model="input.birth"
                    class="input"
                    :class="{'is-danger': validationErrors.birth}"
                    type="date"
                    placeholder=""
                  >
                </p>
                <p
                  v-if="validationErrors.birth"
                  class="help is-danger"
                >
                  This field is invalid
                </p>
              </div>
              <div class="field">
                <label class="label">Email*</label>
                <p class="control">
                  <input
                    v-model="input.email"
                    class="input"
                    :class="{'is-danger': validationErrors.email}"
                    type="email"
                    placeholder="jsmith@example.com"
                  >
                </p>
                <p
                  v-if="validationErrors.email"
                  class="help is-danger"
                >
                  This field is invalid
                </p>
              </div>
              <div class="field">
                <label class="label">City*</label>
                <p class="control">
                  <input
                    v-model="input.address.city"
                    class="input"
                    :class="{'is-danger': validationErrors.city}"
                    type="text"
                    placeholder=""
                  >
                </p>
                <p
                  v-if="validationErrors.city"
                  class="help is-danger"
                >
                  This field is invalid
                </p>
              </div>
              <div class="field">
                <label class="label">State*</label>
                <p class="control">
                  <select
                    v-model="input.address.state"
                    class="input"
                    :class="{'is-danger': validationErrors.state}"
                    placeholder=""
                  >
                    <option
                      value=""
                      disabled
                      selected
                    >
                      Please Select
                    </option>
                    <option
                      v-for="state in states"
                      :value="state.code"
                    >
                      {{ state.name }}
                    </option>
                  </select>
                </p>
                <p
                  v-if="validationErrors.state"
                  class="help is-danger"
                >
                  This field is invalid
                </p>
              </div>
              <div class="field">
                <label class="label">ZIP*</label>
                <p class="control">
                  <input
                    v-model="input.address.zip"
                    class="input"
                    :class="{'is-danger': validationErrors.zip}"
                    type="number"
                    placeholder=""
                  >
                </p>
                <p
                  v-if="validationErrors.zip"
                  class="help is-danger"
                >
                  This field is invalid
                </p>
              </div>
              <div class="field">
                <label class="label">Referred By</label>
                <p class="control">
                <div
                    v-if="referred_by != null"
                    class="field"
                >
                  <div class="card is-info">
                    <div class="columns">
                      <div class="column is-vcentered">
                        <div>
                          {{ referred_by.first }} {{ referred_by.middle }}
                          {{ referred_by.last }}
                        </div>
                        <div>{{ referred_by.ahlid }}</div>
                      </div>
                      <div class="column is-vcentered">
                        <div
                            class="is-pulled-right has-text-danger icon"
                            @click="removeLinkedMyAHL()"
                        >
                          <a
                              class="delete is-medium"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                    v-if="!referred_by"
                    class="field"
                >
                  <div
                      class="button is-info"
                      @click="showLinkMyAHLDialog()"
                  >
                    Select Player
                  </div>
                </div>
                </p>
              </div>
              <div class="field mt-4">
                <div class="control">
                  <label class="checkbox">
                    <input
                      v-model="input.updates"
                      type="checkbox"
                      :checked="input.updates"
                    >
                    Check to receive our AHL Email and bonus chips at every game!
                  </label>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="box">
                <small>
                  This page allows you to sign up as a new member with AHLPoker.com.
                  You can also create a handle which is how you will be known in the AHL community.
                  Personal information such as address, phone, D.O.B. and email
                  address will not be visible to other players at any time.
                </small>
                <br>
                <small>
                  If you have already submitted a <strong>registration form</strong> at an AHL
                  event please allow us up to 72 hours to process your membership request.
                  Remember to read through the terms and conditions before completing your
                  registration.
                </small>
                <br>
                <small class="has-text-centered">
                  <strong>Thank you and good luck.</strong>
                </small>
              </div>
              <div class="box">
                <small>
                  AHL Poker Inc. provides a fun, safe environment to play Texas Hold’em live.
                  By becoming a member of the AHL you agree to all rules set forth by AHL Poker
                  Inc. and its affiliates as well as the following Terms and Conditions. AHL Poker
                  Inc. reserves the right to ban any member who violates our rules at any time.
                </small>
              </div>
              <span class="has-text-danger">Optional</span><hr>
              <div class="field">
                <div class="control">
                  <label class="label">Phone number</label>
                  <input
                    v-model="input.phone"
                    class="input"
                    :class="{'is-danger': validationErrors.phone}"
                    type="tel"
                    placeholder="555-555-555"
                  >
                </div>
              </div>
              <p
                v-if="validationErrors.phone"
                class="help is-danger"
              >
                This field is invalid
              </p>
              <!--<div class="field">-->
              <!--<label class="label">Street Address</label>-->
              <!--<p class="control">-->
              <!--<input class="input":class="{'is-danger': validationErrors.street}" v-model="input.address.street" type="text" placeholder=""/>-->
              <!--</p>-->
              <!--<p v-if="validationErrors.street" class="help is-danger">This field is invalid</p>-->
              <!--</div>-->
              <div class="field">
                <label class="label">Poker Nickname</label>
                <p class="control">
                  <input
                    v-model="input.handle"
                    class="input"
                    :class="{'is-danger': validationErrors.handle}"
                    type="text"
                    placeholder=""
                  >
                </p>
                <p
                  v-if="validationErrors.handle"
                  class="help is-danger"
                >
                  This field is invalid
                </p>
              </div>
              <!--<div class="field">-->
              <!--<label class="label">Extension</label>-->
              <!--<p class="control">-->
              <!--<input class="input" :class="{'is-danger': validationErrors.extension}" v-model="input.extension" type="text" placeholder=""/>-->
              <!--</p>-->
              <!--<p v-if="validationErrors.extension" class="help is-danger">This field is invalid</p>-->
              <!--</div>-->
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <div class="field">
                <div class="control">
                  <label class="checkbox">
                    <input
                      v-model="input.tos"
                      type="checkbox"
                      :checked="input.tos"
                    >
                    <span :class="{'has-text-danger': !input.tos}">You have read and agree to the AHL Poker Inc.</span> <router-link to="/terms">Terms & Conditions.</router-link>
                  </label>
                </div>
              </div>
              <!--<div class="field">
                <div
                  class="control"
                  @click="linkFacebook()"
                >
                  <button
                    class="button is-info"
                    type="button"
                  >
                    <i class="fab fa-facebook-square pr-2" /> Link to your Facebook account
                  </button>
                </div>
              </div>-->
              <div class="field">
                <p class="control">
                  <button
                    class="button is-info"
                    type="button"
                    @click="register()"
                  >
                    Register
                  </button>
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="is-clearfix" />
    </div>
    <div class="column is-2" />
  </div>
</template>

<script>
  import axios from 'axios'
  import LinkMyAHL from "@/components/admin/hosts/LinkMyAHL";

  export default {
    name: 'SignupUser',
    data () {
      return {
        referred_by: null,
        signupWindow: false,
        validationErrors: {
          firstName: false,
          middleName: false,
          lastName: false,
          email: false,
          password: false,
          passwordConfirmation: false,
          phone: false,
          street: false,
          city: false,
          state: false,
          zip: false,
          birth: false,
          extension: false,
          handle: false
        },
        input: {
          password: '',
          confirm: '',
          tos: false,
          handle: '',
          first: '',
          middle: '',
          last: '',
          birth: '',
          email: '',
          phone: '',
          extension: '',
          address: {
            street: '',
            city: '',
            state: '',
            zip: ''
          },
          updates: false
        },
        fbid: '',
        states: [
          {name: 'Alabama', code: 'AL'}, {name: 'Alaska', code: 'AK'}, {name: 'Arizona', code: 'AZ'}, {name: 'Arkansas', code: 'AK'}, {name: 'California', code: 'CA'},
          {name: 'Colorado', code: 'CO'}, {name: 'Connecticut', code: 'CT'}, {name: 'Delaware', code: 'DE'}, {name: 'Florida', code: 'FL'},
          {name: 'Georgia', code: 'GA'}, {name: 'Hawaii', code: 'HI'}, {name: 'Idaho', code: 'ID'}, {name: 'Illinois', code: 'IL'},
          {name: 'Indiana', code: 'IN'}, {name: 'Iowa', code: 'IA'}, {name: 'Kansas', code: 'KS'}, {name: 'Kentucky', code: 'KY'},
          {name: 'Louisiana', code: 'LA'}, {name: 'Maine', code: 'ME'}, {name: 'Massachusetts', code: 'MA'}, {name: 'Michigan', code: 'MI'},
          {name: 'Minnesota', code: 'MN'}, {name: 'Mississippi', code: 'MS'}, {name: 'Missouri', code: 'MO'}, {name: 'Montana', code: 'MT'},
          {name: 'Nebraska', code: 'NE'}, {name: 'Nevada', code: 'NV'}, {name: 'New Hampshire', code: 'NH'}, {name: 'New Jersey', code: 'NJ'},
          {name: 'New Mexico', code: 'NM'}, {name: 'New York', code: 'NY'}, {name: 'North Carolina', code: 'NC'}, {name: 'North Dakota', code: 'ND'},
          {name: 'Ohio', code: 'OH'}, {name: 'Oklahoma', code: 'OK'}, {name: 'Oregon', code: 'OR'}, {name: 'Pennsylvania', code: 'PA'},
          {name: 'Rhode Island', code: 'RI'}, {name: 'South Carolina', code: 'SC'}, {name: 'South Dakota', code: 'SD'}, {name: 'Tennessee', code: 'TN'},
          {name: 'Texas', code: 'TX'}, {name: 'Utah', code: 'UT'}, {name: 'Vermont', code: 'VT'}, {name: 'Virginia', code: 'VA'},
          {name: 'Washington', code: 'WA'}, {name: 'West Virginia', code: 'WV'}, {name: 'Wisconsin', code: 'WI'}, {name: 'Wyoming', code: 'WY'}
        ],
        linkMyAHLDialogVisible: false,
      }
    },
    components:{
      LinkMyAHL
    },
    methods: {
      beforeClose() {
        this.linkMyAHLDialogVisible = false
      },
      removeLinkedMyAHL() {
        this.referred_by = null
      },
      linkToMyAHL(id, first, middle, last) {
        this.referred_by = {ahlid: id, first: first, middle: middle, last: last}
        this.linkMyAHLDialogVisible = false;
        this.$modal.hide('linkMyAHL')
      },
      showLinkMyAHLDialog() {
        this.linkMyAHLDialogVisible = !this.linkMyAHLDialogVisible
        if (this.linkMyAHLDialogVisible === true) {
          this.$modal.show(LinkMyAHL, {linkToMyAHL: this.linkToMyAHL, token: this.token, buttonText: 'Select Player', overrideUrl: 'member/myahlsearch'}, {
            name: 'linkMyAHL',
            resizable: true,
            adaptive: true,
            draggable: true,
          }, {
            'before-close': this.beforeClose
          })
        }
      },
      toggleSignup () {
        this.signupWindow = !this.signupWindow
      },
      validation () {
        let obj = this.validationErrors
        for (let key in obj) {
          obj[key] = false
        }
        // Password confirmation
        if (this.input.password !== this.input.confirm || this.input.confirm.length === 0) {
          this.validationErrors.passwordConfirmation = true
        }
        // No HTML tags
        let htmlTagsRegEx = /(<([^>]+)>)/
        if (this.input.first.length === 0 || htmlTagsRegEx.test(this.input.first)) {
          this.validationErrors.firstName = true
        }
        if (this.input.password.length === 0 || htmlTagsRegEx.test(this.input.password)) {
          this.validationErrors.password = true
        }
//        if (this.input.middle.length === 0 || htmlTagsRegEx.test(this.input.middle)) {
//          this.validationErrors.middleName = true
//        }
        if (this.input.last.length === 0 || htmlTagsRegEx.test(this.input.last)) {
          this.validationErrors.lastName = true
        }
//        if (this.input.handle.length === 0 || htmlTagsRegEx.test(this.input.handle)) {
//          this.validationErrors.handle = true
//        }
        if (this.input.birth.length === 0 || htmlTagsRegEx.test(this.input.birth)) {
          this.validationErrors.birth = true
        }
//        if (this.input.extension.length === 0 || htmlTagsRegEx.test(this.input.extension)) {
//          this.validationErrors.extension = true
//        }
//        if (this.input.address.street.length === 0 || htmlTagsRegEx.test(this.input.address.street)) {
//          this.validationErrors.street = true
//        }
        if (this.input.address.city.length === 0 || htmlTagsRegEx.test(this.input.address.city)) {
          this.validationErrors.city = true
        }
        if (this.input.address.state.length === 0 || htmlTagsRegEx.test(this.input.address.state)) {
          this.validationErrors.state = true
        }
        // Email validation
        let emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!emailRegEx.test(this.input.email)) {
          this.validationErrors.email = true
        }
        // Numbers only
        let numbersRegEx = /^\d+$/
//        if (this.input.phone.length === 0 || !numbersRegEx.test(this.input.phone)) {
//          this.validationErrors.phone = true
//        }
        // ZIP validation (must be 5 chars)
        if (this.input.address.zip.length !== 5 || !numbersRegEx.test(+this.input.address.zip)) {
          this.validationErrors.zip = true
        }
//        // Date validation
//        let dateRegEx = /^(\d{4})-(\d{1,2})-(\d{1,2})$/
//        if (this.input.birth.length === 0 || dateRegEx.test(this.input.birth)) {
//          this.validationErrors.birth = true
//        }
        for (let key in obj) {
          if (obj[key] === true) {
            return false
          }
        }
        if (!this.input.tos) {
          return false
        }
        return true
      },
      register () {
        let self = this
        let updates
        if (this.input.updates) {
          updates = 1
        } else updates = 0
        if (!this.validation()) {
          return console.log('validation failed')
        }
          /* eslint-disable */
        this.$axios({
          method: 'POST',
          url: 'authenticate/register',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            password: self.input.password,
            confirm: self.input.confirm,
            tos: self.input.tos,
            handle: self.input.handle,
            first: self.input.first,
            middle: self.input.middle,
            last: self.input.last,
            dob: self.input.birth,
            email: self.input.email,
            phone: self.input.phone,
            ext: self.input.extension,
            street: self.input.address.street,
            city: self.input.address.city,
            state: self.input.address.state,
            zip: self.input.address.zip,
            updates: updates,
            userid: self.fbid,
            referred_by: self.referred_by ? self.referred_by.ahlid : null,
          }
        })
          .then((res) => {
            if (this.rememberMe) {
              window.localStorage.setItem('isLoggedIn', JSON.stringify(res.data))
            }
            this.$emit('message',
              {
                showDialog: true,
                error: res.data.error,
                message: res.data.message
              })
            if (!res.data.error) {
              this.$emit('loginUser', res.data)
              this.$router.push('/')
            }
          })
          .catch((error) => {
            this.$emit('message',              {                error: true,     showDialog: true,           message: error.response.data.message              })
          })
      },
        /* eslint-enable */
      linkFacebook () {
        window.FB.getLoginStatus((response) => {
          if (response.status === 'connected') {
            window.FB.api('/me?fields=id,address,name,birthday,email,first_name,last_name,middle_name', (response) => {
              if (response.first_name) {
                this.input.first = response.first_name
              }
              if (response.middle_name) {
                this.input.middle = response.middle_name
              }
              if (response.last_name) {
                this.input.last = response.last_name
              }
              if (response.address) {
                this.input.address = response.address
              }
              if (response.email) {
                this.input.email = response.email
              }
              this.fbid = response.id
            })
          } else {
            window.FB.login((res) => {
              window.FB.api('/me?fields=id,address,name,birthday,email,first_name,last_name,middle_name', (response) => {
                if (response.first_name) {
                  this.input.first = response.first_name
                }
                if (response.middle_name) {
                  this.input.middle = response.middle_name
                }
                if (response.last_name) {
                  this.input.last = response.last_name
                }
                if (response.address) {
                  this.input.address = response.address
                }
                if (response.email) {
                  this.input.email = response.email
                }
                this.fbid = response.id
              })
            })
          }
        })
      }
    }
  }
</script>
